import React from 'react';
import { Helmet } from 'react-helmet';
import { Row, Col } from 'react-flexbox-grid';
import { TransitionEaseInOne } from '../common/transitions';
import amandaImg from '../images/farmfit/IMG_7134.jpg';

const FarmFitAbout = () => {
    return (
        <>
            <Helmet>
                <title>About Farm Fit Training | Our Story</title>
                <meta name="description" content="Learn about Farm Fit Training's journey from a family farm to helping thousands across the country achieve their fitness goals." />
            </Helmet>
            <section className="farmfit-about-section">
                <div className="container">
                    <Row>
                        <Col xs={12}>
                            <TransitionEaseInOne>
                                <div className="farmfit-about-flex">
                                    <div className="about-img-wrapper">
                                        <img src={amandaImg} alt="Amanda - FarmFitMomma" className="about-amanda-img" />
                                        <div className="about-amanda-name">Amanda</div>
                                    </div>
                                    <div className="farmfit-about-content">
                                        <h1>About <span className="about-amanda-name-inline">Farm Fit Training</span></h1>

                                        <div className="story-section">
                                            <p>
                                                Hi, I'm Amanda — founder of Farm Fit Training.
                                            </p>
                                            <p>
                                                What started on our family farm as a personal journey to rebuild my physical and mental health has grown into a movement that's helped thousands across the country.
                                            </p>
                                            <p>
                                                Nutrition by FarmFit was created to simplify how my clients eat — macro-aligned, delicious, and totally realistic. It's the same system I use in my 1:1 coaching and Legacy programs.
                                            </p>
                                            <p>
                                                No fads. No fluff. Just food that fits your goals and lifestyle.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </TransitionEaseInOne>
                        </Col>
                    </Row>
                </div>
            </section>
        </>
    );
};

export default FarmFitAbout; 